var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDashboard(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0.954,
    y1: 0.957,
    x2: 0.026,
    y2: 0.047,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#0078c5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00c8ad"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Dashboard_Icon",
    "data-name": "Dashboard Icon",
    transform: "translate(-12 -134)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_62",
    "data-name": "Rectangle 62",
    width: 32,
    height: 32,
    rx: 4,
    transform: "translate(12 134)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "bxs-dashboard",
    transform: "translate(12 134)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_25",
    "data-name": "Path 25",
    d: "M7.111,17.111h6.667A1.111,1.111,0,0,0,14.889,16V7.111A1.111,1.111,0,0,0,13.778,6H7.111A1.111,1.111,0,0,0,6,7.111V16A1.111,1.111,0,0,0,7.111,17.111ZM6,24.889A1.111,1.111,0,0,0,7.111,26h6.667a1.111,1.111,0,0,0,1.111-1.111V20.444a1.111,1.111,0,0,0-1.111-1.111H7.111A1.111,1.111,0,0,0,6,20.444Zm11.111,0A1.111,1.111,0,0,0,18.222,26h6.667A1.111,1.111,0,0,0,26,24.889V17.111A1.111,1.111,0,0,0,24.889,16H18.222a1.111,1.111,0,0,0-1.111,1.111Zm1.111-11.111h6.667A1.111,1.111,0,0,0,26,12.667V7.111A1.111,1.111,0,0,0,24.889,6H18.222a1.111,1.111,0,0,0-1.111,1.111v5.556A1.111,1.111,0,0,0,18.222,13.778Z",
    fill: "#fff"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashboard);
export default __webpack_public_path__ + "static/media/dashboard.50c8df465729517038638fba9f9ea360.svg";
export { ForwardRef as ReactComponent };